import {Heading} from '@primer/react'

import {LABELS} from '../../constants/labels'
import styles from './AppTitle.module.css'

export function AppTitle() {
  return (
    <div className={styles.AppTitleContainer}>
      <Heading id="sidebar-title" as="h2" className={styles.Heading}>
        <span>{LABELS.appHeader}</span>
      </Heading>
    </div>
  )
}
